const COLOR_SCHEME_VALUES = ['dark', 'light', 'system']

// * Do not change themeCookieName cookie key unless the change is aligned with IDP service
const themeCookieName = "jti-theme"

const getRootDomain = (hostname) => {
  const parts = hostname.split('.').filter(Boolean)
  if (parts.length < 2) return hostname
  return parts.slice(-2).join('.')
}

export const getColorSchemeFromCookies = () =>
  document.cookie
    .split(';')
    .map(c => c.trim().split('='))
    .find(([k, v]) => k === themeCookieName && COLOR_SCHEME_VALUES.includes(v))?.[1]

export const addColorSchemeToCookies = scheme => {
  const cookieDomain = getRootDomain(window.location.hostname)
  if (COLOR_SCHEME_VALUES.includes(scheme)) {
    document.cookie = `${themeCookieName}=${scheme}; domain=${cookieDomain}; path=/; SameSite=Lax;`
  }
}
